import _ from 'underscore';
import { parseSync } from '@bingads-webui/safe-json';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';

import { PERFORMANCE_INSIGHTS_ISSUE } from '../constants/consts';

export const normalizeData = ({ checkpointResults, i18n, serverContext }) => {
  const result = {};
  _.each(checkpointResults, (checkpointResult) => {
    const { CheckpointDataMap, CheckpointKey } = checkpointResult;
    const { CheckpointDataJsonString } = CheckpointDataMap[0];
    const CheckpointData = parseSync(CheckpointDataJsonString);
    let normalizedData = {};
    if (CheckpointKey === PERFORMANCE_INSIGHTS_ISSUE.BID) {
      const { BidPoints } = CheckpointData[0];
      const reversedBidPoints = BidPoints.reverse();
      normalizedData = {
        startDate: i18n.formatDate(new Date(_.first(reversedBidPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        endDate: i18n.formatDate(new Date(_.last(reversedBidPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        missedConversions: CheckpointData[0].MissingConversion,
        latestActualTarget: CheckpointData[0].LatestActualTarget,
        latestSuggestTarget: CheckpointData[0].LatestSuggestTarget,
        verticalTarget: 1.77, // TODO CheckpointData[0].VerticalTarget,
        verticalPercentage: 30, // TODO CheckpointData[0].VerticalPercentage,
        localizedLatestActualTarget: i18n.formatCurrency(
          CheckpointData[0].LatestActualTarget,
          _.get(serverContext, ['CurrentAccount', 'CurrencyCode'])
        ),
        localizedLatestSuggestTarget: i18n.formatCurrency(
          CheckpointData[0].LatestSuggestTarget,
          _.get(serverContext, ['CurrentAccount', 'CurrencyCode'])
        ),
        localizedVerticalTarget: i18n.formatCurrency(
          1.77, // TODO CheckpointData[0].VerticalTarget,
          _.get(serverContext, ['CurrentAccount', 'CurrencyCode'])
        ),
        actualBidPoints: _.map(reversedBidPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Actual_Conversion,
        })),
        estimatedBidPoints: _.map(reversedBidPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Estimate_Conversion,
        })),
      };
    } else if (CheckpointKey === PERFORMANCE_INSIGHTS_ISSUE.BUDGET) {
      const { BudgetPoints } = CheckpointData[0];
      const reversedBudgetPoints = BudgetPoints.reverse();
      normalizedData = {
        startDate: i18n.formatDate(new Date(_.first(reversedBudgetPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        endDate: i18n.formatDate(new Date(_.last(reversedBudgetPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        missedImpressions: CheckpointData[0].MissingImpressions,
        actualBudget: CheckpointData[0].OriginalBudget,
        recommendedBudget: CheckpointData[0].RecommendedBudget,
        localizedActualBudget: i18n.formatCurrency(
          CheckpointData[0].OriginalBudget,
          _.get(serverContext, ['CurrentAccount', 'CurrencyCode'])
        ),
        localizedRecommendedBudget: i18n.formatCurrency(
          CheckpointData[0].RecommendedBudget,
          _.get(serverContext, ['CurrentAccount', 'CurrencyCode'])
        ),
        actualBudgetPoints: _.map(reversedBudgetPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Impressions,
        })),
        estimatedBudgetPoints: _.map(reversedBudgetPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.ProjectedImpressionsRecommendedBudget,
        })),
      };
    }
    result[CheckpointKey] = normalizedData;
  });
  return result;
};

export const getColor = (metricName) => {
  if (metricName === 'Actual') {
    return '#9373C0';
  } else if (metricName === 'Projected') {
    return '#4F6BED';
  } else if (metricName === 'Impressions') {
    return 'rgba(42, 160, 164, 1)';
  }
  return 'gray';
};
